import {
	defineMessages
} from "react-intl";

export default defineMessages({
	"survey.answers.0": {
		"id": "survey.answers.0",
		"defaultMessage": "Enter your age"
	},
	"survey.answers.1": {
		"id": "survey.answers.1",
		"defaultMessage": "Select your Country"
	},
	"survey.answers.2": {
		"id": "survey.answers.2",
		"defaultMessage": "Male"
	},
	"survey.answers.3": {
		"id": "survey.answers.3",
		"defaultMessage": "Female"
	},
	"survey.answers.4": {
		"id": "survey.answers.4",
		"defaultMessage": "Genderqueer"
	},
	"survey.answers.5": {
		"id": "survey.answers.5",
		"defaultMessage": "Good"
	},
	"survey.answers.6": {
		"id": "survey.answers.6",
		"defaultMessage": "Bad"
	},
	"survey.answers.7": {
		"id": "survey.answers.7",
		"defaultMessage": "I don't care"
	},
	"survey.answers.8": {
		"id": "survey.answers.8",
		"defaultMessage": "no tent"
	},
	"survey.answers.9": {
		"id": "survey.answers.9",
		"defaultMessage": "self-made tent"
	},
	"survey.answers.10": {
		"id": "survey.answers.10",
		"defaultMessage": "My brand of a tent"
	},
	"survey.answers.11": {
		"id": "survey.answers.11",
		"defaultMessage": "width X height X length"
	},
	"survey.answers.12": {
		"id": "survey.answers.12",
		"defaultMessage": "Light Emitting Diodes (LEDs)"
	},
	"survey.answers.13": {
		"id": "survey.answers.13",
		"defaultMessage": "Metal Halide (MH)"
	},
	"survey.answers.14": {
		"id": "survey.answers.14",
		"defaultMessage": "Ceramic Metal Halide (CMH, CDM)"
	},
	"survey.answers.15": {
		"id": "survey.answers.15",
		"defaultMessage": "Combination MH and HPS (\"Dual arc\")"
	},
	"survey.answers.16": {
		"id": "survey.answers.16",
		"defaultMessage": "High-Pressure Sodium (HPS)"
	},
	"survey.answers.17": {
		"id": "survey.answers.17",
		"defaultMessage": "Brand"
	},
	"survey.answers.18": {
		"id": "survey.answers.18",
		"defaultMessage": "Yes"
	},
	"survey.answers.19": {
		"id": "survey.answers.19",
		"defaultMessage": "No"
	},
	"survey.answers.20": {
		"id": "survey.answers.20",
		"defaultMessage": "Yes"
	},
	"survey.answers.21": {
		"id": "survey.answers.21",
		"defaultMessage": "No"
	},
	"survey.answers.22": {
		"id": "survey.answers.22",
		"defaultMessage": "Yes"
	},
	"survey.answers.23": {
		"id": "survey.answers.23",
		"defaultMessage": "No"
	},
	"survey.answers.24": {
		"id": "survey.answers.24",
		"defaultMessage": "I'm not using fertilizers"
	},
	"survey.answers.25": {
		"id": "survey.answers.25",
		"defaultMessage": "Choose a brand"
	},
	"survey.answers.26": {
		"id": "survey.answers.26",
		"defaultMessage": "No"
	},
	"survey.answers.27": {
		"id": "survey.answers.27",
		"defaultMessage": "Yes"
	},
	"survey.answers.28": {
		"id": "survey.answers.28",
		"defaultMessage": "Illumination"
	},
	"survey.answers.29": {
		"id": "survey.answers.29",
		"defaultMessage": "Water level"
	},
	"survey.answers.30": {
		"id": "survey.answers.30",
		"defaultMessage": "Humidity"
	},
	"survey.answers.31": {
		"id": "survey.answers.31",
		"defaultMessage": "Temperature"
	},
	"survey.answers.32": {
		"id": "survey.answers.32",
		"defaultMessage": "PH"
	},
	"survey.answers.33": {
		"id": "survey.answers.33",
		"defaultMessage": "Mineralization/EC"
	},
	"survey.answers.34": {
		"id": "survey.answers.34",
		"defaultMessage": "Is water saving important for you?"
	},
	"survey.answers.35": {
		"id": "survey.answers.35",
		"defaultMessage": "Is electricity saving important for you?"
	},
	"survey.answers.36": {
		"id": "survey.answers.36",
		"defaultMessage": "Are you open for trying new and revolutionary system of growing for your plant?"
	},
	"survey.answers.37": {
		"id": "survey.answers.37",
		"defaultMessage": "Yes"
	},
	"survey.answers.38": {
		"id": "survey.answers.38",
		"defaultMessage": "No"
	},
	"survey.answers.39": {
		"id": "survey.answers.39",
		"defaultMessage": "No, but going to"
	},
	"survey.answers.40": {
		"id": "survey.answers.40",
		"defaultMessage": "Buisnes"
	},
	"survey.answers.41": {
		"id": "survey.answers.41",
		"defaultMessage": "Eco"
	},
	"survey.answers.42": {
		"id": "survey.answers.42",
		"defaultMessage": "Fresh"
	},
	"survey.answers.43": {
		"id": "survey.answers.43",
		"defaultMessage": "Select your kind of plant?"
	},
	"survey.answers.44": {
		"id": "survey.answers.44",
		"defaultMessage": "Indoor"
	},
	"survey.answers.45": {
		"id": "survey.answers.45",
		"defaultMessage": "Outdoor"
	},
	"survey.answers.46": {
		"id": "survey.answers.46",
		"defaultMessage": "I like the process"
	},
	"survey.answers.47": {
		"id": "survey.answers.47",
		"defaultMessage": "Your variant"
	},
	"survey.answers.48": {
		"id": "survey.answers.48",
		"defaultMessage": "Input brand name"
	},
	"survey.answers.49": {
		"id": "survey.answers.49",
		"defaultMessage": "How many month in a year you growing?"
	},
	"survey.answers.50": {
		"id": "survey.answers.50",
		"defaultMessage": "Not interesting"
	},
	"survey.answers.51": {
		"id": "survey.answers.51",
		"defaultMessage": "I don't know how?"
	},
	"survey.answers.52": {
		"id": "survey.answers.52",
		"defaultMessage": "Expensive"
	},
	"survey.answers.53": {
		"id": "survey.answers.53",
		"defaultMessage": "Out of time"
	},
	"survey.answers.54": {
		"id": "survey.answers.54",
		"defaultMessage": "Restrictions"
	},
	"survey.answers.55": {
		"id": "survey.answers.55",
		"defaultMessage": "Your feedback about this survey"
	},
	"survey.question.0": {
		"id": "survey.question.0",
		"defaultMessage": "How old are you"
	},
	"survey.question.1": {
		"id": "survey.question.1",
		"defaultMessage": "Country"
	},
	"survey.question.2": {
		"id": "survey.question.2",
		"defaultMessage": "Gender"
	},
	"survey.question.3": {
		"id": "survey.question.3",
		"defaultMessage": "Brand of your tent"
	},
	"survey.question.4": {
		"id": "survey.question.4",
		"defaultMessage": "Dimensions of your tent"
	},
	"survey.question.5": {
		"id": "survey.question.5",
		"defaultMessage": "Type of your lighting"
	},
	"survey.question.6": {
		"id": "survey.question.6",
		"defaultMessage": "Brand of your lighting"
	},
	"survey.question.7": {
		"id": "survey.question.7",
		"defaultMessage": "Whether you lighting is automated"
	},
	"survey.question.8": {
		"id": "survey.question.8",
		"defaultMessage": "Do you use a hood?"
	},
	"survey.question.9": {
		"id": "survey.question.9",
		"defaultMessage": "Whether you hood is automated?"
	},
	"survey.question.10": {
		"id": "survey.question.10",
		"defaultMessage": "Brand of your fertilizers?"
	},
	"survey.question.11": {
		"id": "survey.question.11",
		"defaultMessage": "Whether your fertilizer is automated?"
	},
	"survey.question.12": {
		"id": "survey.question.12",
		"defaultMessage": "What indicators do you take into consideration while growing"
	},
	"survey.question.13": {
		"id": "survey.question.13",
		"defaultMessage": "Make your chose"
	},
	"survey.question.14": {
		"id": "survey.question.14",
		"defaultMessage": "How many plants do grow simultaneously?"
	},
	"survey.question.15": {
		"id": "survey.question.15",
		"defaultMessage": "Your position to MJ"
	},
	"survey.question.16": {
		"id": "survey.question.16",
		"defaultMessage": "Do you grow any plants?"
	},
	"survey.question.17": {
		"id": "survey.question.17",
		"defaultMessage": "Why do you grow?"
	},
	"survey.question.18": {
		"id": "survey.question.18",
		"defaultMessage": "What kind of plant do you grow?"
	},
	"survey.question.19": {
		"id": "survey.question.19",
		"defaultMessage": "Way of growing?"
	},
	"survey.question.20": {
		"id": "survey.question.20",
		"defaultMessage": "Brand fertilizer?"
	},
	"survey.question.21": {
		"id": "survey.question.21",
		"defaultMessage": "Select month in a year you growing?"
	},
	"survey.question.22": {
		"id": "survey.question.22",
		"defaultMessage": "Reason?"
	},
	"survey.question.23": {
		"id": "survey.question.23",
		"defaultMessage": "Your feedback about this survey"
	}
	
});





// WEBPACK FOOTER //
// ./src/components/Answer/messages.js